import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import CalendarDialog from "../../calendarDialog/CalendarDialog";
import UpperCaseText from "../../../../../utils/UpperCaseText";
import {
  LEASE,
  LEASE_OPTIONS,
  OFFLINELEASE,
} from "../../../../../common/Constants";

import styles from "./LeaseOptions.module.scss";
import HasPermissionTo from "../../../../../common/HasPermissionTo";
import CapitalizeText from "../../../../../utils/CapitalizeText";
import LowerCaseText from "../../../../../utils/LowerCaseText";
import CheckBox from "../../../../../shared/checkBox/CheckBox";
import checkboxStyles from "../../../../../shared/checkBox/CheckBox.module.scss";
import UiDateUtils from "../../../../../utils/UiDateUtils";
import RegistrationNumberDialog from "../financeOptions/registrarionNumberDialog/RegistrationNumberDialog";
import TermsDialog from "../../../../../shared/termsDialog/TermsDialog";
import FileEncoder from "../../../../../utils/FileEncoder";
import CustomerReservationsClient from "../../../../../shared/clients/CustomerReservationsClient";
import { HANDOVER_STATUS } from "../../handOver/Constants";
import { IS_BRITAIN_MARKET } from "../../../../../utils/EmpUtil";
import LeasePricingTooltip from "./LeasePricingTooltip";
import { Tooltip, withStyles } from "@material-ui/core";
import Info from "@material-ui/icons/Info";

const ItemDetails = ({ date, description }) => {
  return (
    <div className={styles.info}>
      {date ? (
        <span className={styles.paymentInfo}>
          {UiDateUtils.formattedDate(date)}
        </span>
      ) : (
        <span className={styles.emptyDate} />
      )}
      {description}
    </div>
  );
};
const StyledInfo = withStyles({
  root: {
    fill: "#4a90e2",
    width: 18,
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: 0,
    cursor: "pointer",
  },
})(Info);

const StyledTooltip = withStyles({
  popper: {
    opacity: 1,
    pointerEvents: "auto",
  },
  tooltip: {
    background: "white",
    boxShadow: "1px 1px 9px 0 rgba(0, 0, 0, 0.27)",
    paddingTop: 28,
    paddingLeft: 28,
    paddingRight: 28,
    paddingBottom: 18,
    maxWidth: 350,
    arrow: true,
  },
})(Tooltip);

class LeaseOptions extends Component {
  constructor(props) {
    super(props);
    this.hasCompletedLeaseContract = false;
    this.hasCompletedPayBalenceToDealer = false;
    this.hasCompletedLeasePayment = false;
    this.canEditPaymentMethod =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "paymentMethod:write"
      );
    this.hasCompletedRegistrationNumber = false;
    this.hasUploadedDealerInvoice = false;
    this.hasUploadedRegistrationCertificate = false;
    this.hasUploadedDeliveryNotes = false;
    this.hasCompletedDelivery = false;
    this.eSignedDate = null;
    this.state = {
      openRegistrationNumberDialog: false,
      openDealerInvoiceDialog: false,
      openDeliveryCertificateDialog: false,
      openDeliveryNotesDialog: false,
      openTooltip: false,
    };
  }

  handleConsumerDownPayment = () => {};

  toggleRegistrationNumberDialog = () => {
    this.setState((prevState) => ({
      openRegistrationNumberDialog: !prevState.openRegistrationNumberDialog,
    }));
  };

  toggleDealerInvoiceDialog = () => {
    this.setState((prevState) => ({
      openDealerInvoiceDialog: !prevState.openDealerInvoiceDialog,
    }));
  };

  toggleDeliveryNotesDialog = () => {
    this.setState((prevState) => ({
      openDeliveryNotesDialog: !prevState.openDeliveryNotesDialog,
    }));
  };

  toggleRegistrationCertificateDialog = () => {
    this.setState((prevState) => ({
      openDeliveryCertificateDialog: !prevState.openDeliveryCertificateDialog,
    }));
  };

  saveRegistrationData = (number, dateFce, dateSap) => {
    this.props.updateRegistrationData(
      number,
      dateSap,
      dateSap,
      this.props.customerReservation.vinNumber,
      LEASE
    );
    this.toggleRegistrationNumberDialog();
  };

  hasCompletedHandover = () => {
    const handoverappointmentConfirmedData =
      this.props.customerReservation.handoverappointmentConfirmedData;

    if (
      IS_BRITAIN_MARKET(this.props.selectedMarket) &&
      LowerCaseText(this.props.paymentType) === LEASE &&
      handoverappointmentConfirmedData &&
      handoverappointmentConfirmedData.appointmentInfoData
    ) {
      const appointmentStatuses =
        handoverappointmentConfirmedData.appointmentInfoData
          .filter(
            (appointmentInfo) => appointmentInfo.appointmentStatus !== null
          )
          .map((appointmentInfo) => {
            return appointmentInfo.appointmentStatus;
          });
      if (appointmentStatuses) {
        if (appointmentStatuses.includes(HANDOVER_STATUS.RECEIVED)) {
          this.hasCompletedDelivery = true;
        }
      }
    }
  };

  /*For testing previous lease action for online and offline actions*/
  checkHasCompletedPreviousActions() {
    const customerReservation = this.props.customerReservation;
    this.hasCompletedPayBalenceToDealer =
      customerReservation.balancePaymentData &&
      customerReservation.balancePaymentData.paymentDate !== null;
    this.hasCompletedLeasePayment =
      customerReservation.finalPaymentConfirmedData &&
      customerReservation.finalPaymentConfirmedData.dealerAcceptedDate !== null;
    this.hasCompletedRegistrationNumber =
      customerReservation.registrationDetails &&
      customerReservation.registrationDetails.registrationNumber !== null &&
      customerReservation.registrationDetails.registrationDate !== null;
    this.hasUploadedDealerInvoice =
      customerReservation.uploadDealerInvoiceData &&
      customerReservation.uploadDealerInvoiceData.dealerActionDate !== null;
    this.hasUploadedRegistrationCertificate =
      customerReservation.certificateOfRegUploadData &&
      customerReservation.certificateOfRegUploadData.dealerActionDate !== null;
    this.hasUploadedDeliveryNotes =
      customerReservation.deliveryNotesData &&
      customerReservation.deliveryNotesData.dealerActionDate !== null;
    this.leaseContractData(this.props.customerReservation.paymentDescription);
    this.hasCompletedHandover();
  }

  leaseContractData = (paymentDesc) => {
    if (
      LEASE_OPTIONS.LEASE_CONTRACT_AUTO_TICK.includes(
        UpperCaseText(this.props.selectedMarket)
      ) &&
      LowerCaseText(this.props.paymentType) === LEASE
    ) {
      paymentDesc &&
        paymentDesc.length > 0 &&
        paymentDesc.forEach((item) => {
          if (UpperCaseText(item.status) === LEASE_OPTIONS.COMPLETED) {
            this.eSignedDate = item.date;
          }
        });
      this.hasCompletedLeaseContract = this.eSignedDate !== null;
    } else {
      this.hasCompletedLeaseContract =
        this.props.customerReservation.contractSignedData &&
        this.props.customerReservation.contractSignedData.dealerAcceptedDate !==
          null;
    }
  };

  isLeaseContractCheckboxDisabled = () => {
    return LowerCaseText(this.props.paymentType) === OFFLINELEASE
      ? this.hasCompletedPreviousOption("leaseContractSigned") ||
          this.hasCompletedLeaseContract ||
          !this.canEditPaymentMethod
      : this.hasCompletedPreviousOption("leaseContractSignedOnline") ||
          IS_BRITAIN_MARKET(this.props.selectedMarket) ||
          this.hasCompletedLeaseContract ||
          !this.canEditPaymentMethod;
  };

  isPayBalencetoDealerCheckboxDisabled = () => {
    return LowerCaseText(this.props.paymentType) === LEASE
      ? this.hasCompletedPreviousOption("leasePayBalence") ||
          this.hasCompletedPayBalenceToDealer ||
          !this.canEditPaymentMethod
      : this.hasCompletedPayBalenceToDealer;
  };

  uploadDealerInvoice = (dealerId, file) => {
    this.props.hideOrShow(true);
    this.toggleDealerInvoiceDialog();
    new FileEncoder().encode(file).then((data) => {
      const dealerInvoiceRequest = {
        dealerAction: "uploaddealerinvoice",
        token: this.props.user.token,
        commonIds: this.props.user.dealerId,
        userId: this.props.user.userId,
        fileName: file.name,
        fileData: data,
        dealerId: this.props.customerReservation.dealerId,
        fileType: "pdf",
        orderId: this.props.reservationId,
      };
      CustomerReservationsClient.uploadLeaseDocument(
        "dealer-invoice",
        dealerInvoiceRequest
      )
        .then(() => {
          this.props.removeDocNotifications("DEALER_INVOICE");
        })
        .catch(() => {})
        .finally(() => {
          this.props.hideOrShow(false);
        });
    });
  };

  uploadRegistrationCertificate = (dealerId, file) => {
    this.props.hideOrShow(true);
    this.toggleRegistrationCertificateDialog();

    new FileEncoder().encode(file).then((data) => {
      const dealerInvoiceRequest = {
        dealerAction: "certificateOfRegUpload",
        token: this.props.user.token,
        commonIds: this.props.user.dealerId,
        userId: this.props.user.userId,
        fileName: file.name,
        fileData: data,
        dealerId: this.props.customerReservation.dealerId,
        fileType: "pdf",
        orderId: this.props.reservationId,
      };
      CustomerReservationsClient.uploadLeaseDocument(
        "registration-certificate",
        dealerInvoiceRequest
      )
        .then(() => {
          this.props.removeDocNotifications("CERTIFICATE_OF_REGISTRATION");
        })
        .catch(() => {})
        .finally(() => {
          this.props.hideOrShow(false);
        });
    });
  };

  uploadDeliveryNotes = (dealerId, file) => {
    this.props.hideOrShow(true);
    this.toggleDeliveryNotesDialog();

    new FileEncoder().encode(file).then((data) => {
      const dealerInvoiceRequest = {
        dealerAction: "deliveryNotes",
        token: this.props.user.token,
        commonIds: this.props.user.dealerId,
        userId: this.props.user.userId,
        fileName: file.name,
        fileData: data,
        dealerId: this.props.customerReservation.dealerId,
        fileType: "pdf",
        orderId: this.props.reservationId,
      };
      CustomerReservationsClient.uploadLeaseDocument(
        "delivery-notes",
        dealerInvoiceRequest
      )
        .then(() => {
          this.props.removeDocNotifications("DELIVERY_NOTE");
        })
        .catch(() => {})
        .finally(() => {
          this.props.hideOrShow(false);
        });
    });
  };

  hasCompletedPreviousOption = (id) => {
    let previousStep = null;

    const options = LEASE_OPTIONS[UpperCaseText(this.props.selectedMarket)];
    options &&
      options.forEach((item) => {
        if (item.key === id) {
          if (!item.hasPrevious) {
            previousStep = false;
          } else {
            previousStep = item.previousKey;
          }
        }
      });
    switch (previousStep) {
      case "leaseContractSigned":
        return !this.hasCompletedLeaseContract;
      case "leasePayBalence":
        return !this.hasCompletedPayBalenceToDealer;
      case "registrationNumber":
        return !this.hasCompletedRegistrationNumber;
      case "leaseContractSignedOnline":
        return !this.hasCompletedLeaseContract;
      case "dealerInvoice":
        return !this.hasUploadedDealerInvoice;
      case "certificateRegistration":
        return !this.hasUploadedRegistrationCertificate;
      case "deliveryNotes":
        return !this.hasUploadedDeliveryNotes;
      case "leasePayment":
        return !this.hasCompletedLeasePayment;
      default:
        return previousStep;
    }
  };

  saveLeaseOption = (acceptedDate, type) => {
    this.props.handleUpdateOrder(type, acceptedDate);
  };

  isLeasePaymentCheckboxDisabled = () => {
    return LowerCaseText(this.props.paymentType) === LEASE
      ? this.hasCompletedPreviousOption("leasePayment") ||
          this.hasCompletedLeasePayment ||
          !this.canEditPaymentMethod
      : this.hasCompletedLeasePayment;
  };

  isLeaseContractEnable = () => {
    return (
      LowerCaseText(this.props.paymentType) === OFFLINELEASE ||
      LEASE_OPTIONS.ONLINE_APPROVED_MARKETS.includes(
        UpperCaseText(this.props.selectedMarket)
      )
    );
  };

  toggleTooltip = () => {
    this.setState((prevState) => ({
      openTooltip: !prevState.openTooltip,
    }));
  };

  closeTooltip = () => {
    this.setState({
      openTooltip: false,
    });
  };

  render() {
    this.checkHasCompletedPreviousActions();
    return (
      <div>
        {/*Registration Number will be only for the online UK approved orders*/}
        <HasPermissionTo
          perform={["leaseRegistrationNumber:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={
            LowerCaseText(this.props.paymentType) === LEASE &&
            IS_BRITAIN_MARKET(this.props.selectedMarket)
          }
          render={() => {
            return (
              <div data-testId="registrationNumber">
                <div className={styles.rowContainer}>
                  <span>
                    <CheckBox
                      id="registration_Number_id"
                      checked={this.hasCompletedRegistrationNumber}
                      isDisabled={
                        this.hasCompletedPreviousOption("registrationNumber") ||
                        this.hasCompletedRegistrationNumber ||
                        !this.canEditPaymentMethod
                      }
                      label={this.props.t("PMRegistrationNumber.title")}
                      onChange={this.toggleRegistrationNumberDialog}
                      textClass={
                        this.hasCompletedPreviousOption("registrationNumber") ||
                        this.hasCompletedRegistrationNumber ||
                        !this.canEditPaymentMethod
                          ? this.hasCompletedRegistrationNumber
                            ? checkboxStyles.boldLabel
                            : checkboxStyles.disabledLabel
                          : checkboxStyles.boldLabel
                      }
                    />
                  </span>
                  <span className={styles.leaseTooltip}>
                    <StyledTooltip
                      data-testid="leaseTooltip"
                      open={this.state.openTooltip}
                      placement="bottom-start"
                      title={
                        <LeasePricingTooltip closeTooltip={this.closeTooltip} />
                      }
                    >
                      <StyledInfo
                        onClick={this.toggleTooltip}
                        fontSize="small"
                      />
                    </StyledTooltip>
                  </span>
                </div>
                {this.hasCompletedRegistrationNumber && (
                  <>
                    <ItemDetails
                      date={
                        this.props.customerReservation.registrationDetails
                          .dealerActionDate
                      }
                      description={
                        <>
                          <span className={styles.acceptGreen}>
                            {this.props.t("PMRegistrationNumber.recordedBy")}
                          </span>
                          <span className={styles.detailsText}>
                            {CapitalizeText(
                              this.props.customerReservation.registrationDetails
                                .dealerActionUserId
                            )}
                          </span>
                        </>
                      }
                    />
                    <ItemDetails
                      description={
                        <>
                          <span className={styles.dateText}>
                            {this.props.t("PMRegistrationNumber.regNumber")}
                          </span>
                          <span className={styles.detailsText}>
                            {
                              this.props.customerReservation.registrationDetails
                                .registrationNumber
                            }
                          </span>
                        </>
                      }
                    />
                    <ItemDetails
                      description={
                        <>
                          <span className={styles.dateText}>
                            {this.props.t(
                              "PMRegistrationNumber.dateRegistered"
                            )}
                          </span>
                          <span className={styles.detailsText}>
                            {UiDateUtils.formattedDate(
                              this.props.customerReservation.registrationDetails
                                .registrationDate
                            )}
                          </span>
                        </>
                      }
                    />
                  </>
                )}
              </div>
            );
          }}
        />
        {/*Lease contract will be for the both offline and online approved orders*/}
        <HasPermissionTo
          perform={["leaseContract:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={this.isLeaseContractEnable()}
          render={() => {
            return (
              <div data-testId="leaseContract">
                <div className={styles.rowContainer}>
                  <CalendarDialog
                    {...this.props}
                    id="leaseContract"
                    saveCalendarDate={this.saveLeaseOption} //create method to save new date
                    todayDate={this.props.customerReservation.todayDate}
                    type={LEASE_OPTIONS.LEASE_CONTRACT}
                    checkBoxText={this.props.t("PMLeaseContract.leaseContract")}
                    isDisabled={this.isLeaseContractCheckboxDisabled()}
                    isChecked={this.hasCompletedLeaseContract}
                    hasMaxDate={true}
                    dialogTitle={this.props.t("PMLeaseContract.dateSigned")}
                    dialogDescription={this.props.t(
                      "PMLeaseContract.dialogDescription"
                    )}
                  />
                </div>
                {this.hasCompletedLeaseContract &&
                  (this.eSignedDate !== null ? (
                    <ItemDetails
                      date={this.eSignedDate}
                      description={
                        <span className={styles.acceptGreen}>
                          {this.props.t("PMLeaseContract.eSignedOn")}
                        </span>
                      }
                    />
                  ) : (
                    <ItemDetails
                      date={
                        this.props.customerReservation.contractSignedData
                          .dealerAcceptedDate
                      }
                      description={
                        <>
                          <span className={styles.acceptGreen}>
                            {this.props.t("PMLeaseContract.eSigned")}
                          </span>
                          <span className={styles.detailsText}>
                            &nbsp;
                            {CapitalizeText(
                              this.props.customerReservation.contractSignedData
                                .dealerActionUserId
                            )}
                          </span>
                        </>
                      }
                    />
                  ))}
              </div>
            );
          }}
        />
        <HasPermissionTo
          perform={["leaseContract:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={
            LowerCaseText(this.props.paymentType) === LEASE &&
            (LEASE_OPTIONS.ONLINE_APPROVED_MARKETS.includes(
              UpperCaseText(this.props.selectedMarket)
            ) ||
              IS_BRITAIN_MARKET(this.props.selectedMarket))
          }
          render={() => {
            return (
              <div data-testId="payBalanceDealer">
                <div className={styles.downPaymentDiv}>
                  <CheckBox
                    id="payBalenceDealer"
                    checked={this.hasCompletedPayBalenceToDealer}
                    isDisabled={this.isPayBalencetoDealerCheckboxDisabled()}
                    onChange={() => {
                      this.saveLeaseOption(
                        this.props.customerReservation.todayDate,
                        LEASE_OPTIONS.LEASE_OFFLINE_BALANCE_PAYMENT
                      );
                    }}
                    label={this.props.t("PMLeasePayBalance.leasePayBalance")}
                    textClass={
                      this.hasCompletedPreviousOption("leasePayBalence") ||
                      this.hasCompletedPayBalenceToDealer ||
                      !this.canEditPaymentMethod
                        ? this.hasCompletedPayBalenceToDealer
                          ? checkboxStyles.boldLabel
                          : checkboxStyles.disabledLabel
                        : checkboxStyles.boldLabel
                    }
                  />
                </div>
                {this.hasCompletedPayBalenceToDealer && (
                  <ItemDetails
                    date={
                      this.props.customerReservation.balancePaymentData
                        .paymentDate
                    }
                    description={
                      <span className={styles.acceptGreen}>
                        {this.props.t("PMLeasePayBalance.paymentReceived")}
                      </span>
                    }
                  />
                )}
              </div>
            );
          }}
        />

        {/*Upload Dealer Invoice will be only for the online approved orders*/}
        <HasPermissionTo
          perform={["leaseDealerInvoice:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={
            LowerCaseText(this.props.paymentType) === LEASE &&
            IS_BRITAIN_MARKET(this.props.selectedMarket)
          }
          render={() => {
            return (
              <div data-testid="dealerInvoice">
                <div className={styles.rowContainer}>
                  <CheckBox
                    id="dealer_Invoice_id"
                    checked={this.hasUploadedDealerInvoice}
                    isDisabled={
                      this.hasCompletedPreviousOption("dealerInvoice") ||
                      !this.hasCompletedDelivery ||
                      this.hasUploadedDealerInvoice ||
                      !this.canEditPaymentMethod
                    }
                    label={this.props.t("PMDealerInvoice.uploadDealerInvoice")}
                    onChange={this.toggleDealerInvoiceDialog}
                    textClass={
                      this.hasCompletedPreviousOption("dealerInvoice") ||
                      this.hasUploadedDealerInvoice ||
                      !this.canEditPaymentMethod
                        ? this.hasUploadedDealerInvoice
                          ? checkboxStyles.boldLabel
                          : checkboxStyles.disabledLabel
                        : checkboxStyles.boldLabel
                    }
                  />
                  <HasPermissionTo
                    perform={["leaseUpdateDocs:view"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={
                      this.hasUploadedDealerInvoice &&
                      !this.hasCompletedLeasePayment
                    }
                    render={() => {
                      return (
                        <div
                          className={styles.updateText}
                          onClick={this.toggleDealerInvoiceDialog}
                        >
                          {this.props.t("PaymentMethod.update")}
                        </div>
                      );
                    }}
                  />
                </div>
                {this.hasUploadedDealerInvoice && (
                  <ItemDetails
                    date={
                      this.props.customerReservation.uploadDealerInvoiceData
                        .dealerActionDate
                    }
                    description={
                      <>
                        <span className={styles.acceptGreen}>
                          {this.props.t("PMDealerInvoice.invoiceUploaded")}
                        </span>
                        <span className={styles.detailsText}>
                          {CapitalizeText(
                            this.props.customerReservation
                              .uploadDealerInvoiceData.dealerActionUserId
                          )}
                        </span>
                      </>
                    }
                  />
                )}
              </div>
            );
          }}
        />

        {/*Upload Certificate of registration for GBR online lease*/}
        <HasPermissionTo
          perform={["leaseRegistrationCertificate:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={
            LowerCaseText(this.props.paymentType) === LEASE &&
            IS_BRITAIN_MARKET(this.props.selectedMarket)
          }
          render={() => {
            return (
              <div data-testid="deliveryCertificateTestId">
                <div className={styles.rowContainer}>
                  <CheckBox
                    id="deliveryCertificateCheckboxId"
                    checked={this.hasUploadedRegistrationCertificate}
                    isDisabled={
                      this.hasCompletedPreviousOption(
                        "certificateRegistration"
                      ) ||
                      this.hasUploadedRegistrationCertificate ||
                      !this.canEditPaymentMethod
                    }
                    label={this.props.t(
                      "PMDeliveryCertificate.checkBoxCaption"
                    )}
                    onChange={this.toggleRegistrationCertificateDialog}
                    textClass={
                      this.hasCompletedPreviousOption(
                        "certificateRegistration"
                      ) ||
                      this.hasUploadedRegistrationCertificate ||
                      !this.canEditPaymentMethod
                        ? this.hasUploadedRegistrationCertificate
                          ? checkboxStyles.boldLabel
                          : checkboxStyles.disabledLabel
                        : checkboxStyles.boldLabel
                    }
                  />
                  <HasPermissionTo
                    perform={["leaseUpdateDocs:view"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={
                      this.hasUploadedRegistrationCertificate &&
                      !this.hasCompletedLeasePayment
                    }
                    render={() => {
                      return (
                        <div
                          className={styles.updateText}
                          onClick={this.toggleRegistrationCertificateDialog}
                        >
                          {this.props.t("PaymentMethod.update")}
                        </div>
                      );
                    }}
                  />
                </div>
                {this.hasUploadedRegistrationCertificate && (
                  <ItemDetails
                    date={
                      this.props.customerReservation.certificateOfRegUploadData
                        .dealerActionDate
                    }
                    description={
                      <>
                        <span className={styles.acceptGreen}>
                          {this.props.t(
                            "PMDeliveryCertificate.certificateUploaded"
                          )}
                        </span>
                        <span className={styles.detailsText}>
                          {CapitalizeText(
                            this.props.customerReservation
                              .certificateOfRegUploadData.dealerActionUserId
                          )}
                        </span>
                      </>
                    }
                  />
                )}
              </div>
            );
          }}
        />

        {/*Upload Delivery Notes for GBR online lease*/}
        <HasPermissionTo
          perform={["leaseDeliveryNotes:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={
            LowerCaseText(this.props.paymentType) === LEASE &&
            IS_BRITAIN_MARKET(this.props.selectedMarket)
          }
          render={() => {
            return (
              <div data-testid="deliveryNotes">
                <div className={styles.rowContainer}>
                  <CheckBox
                    id="deliveryNotesheckboxId"
                    checked={this.hasUploadedDeliveryNotes}
                    isDisabled={
                      this.hasCompletedPreviousOption("deliveryNotes") ||
                      this.hasUploadedDeliveryNotes ||
                      !this.canEditPaymentMethod
                    }
                    label={this.props.t("PMDeliveryNotes.checkBoxCaption")}
                    onChange={this.toggleDeliveryNotesDialog}
                    textClass={
                      this.hasCompletedPreviousOption("deliveryNotes") ||
                      this.hasUploadedRegistrationCertificate ||
                      !this.canEditPaymentMethod
                        ? this.hasUploadedRegistrationCertificate
                          ? checkboxStyles.boldLabel
                          : checkboxStyles.disabledLabel
                        : checkboxStyles.boldLabel
                    }
                  />
                  <HasPermissionTo
                    perform={["leaseUpdateDocs:view"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={
                      this.hasUploadedDeliveryNotes &&
                      !this.hasCompletedLeasePayment
                    }
                    render={() => {
                      return (
                        <div
                          className={styles.updateText}
                          onClick={this.toggleDeliveryNotesDialog}
                        >
                          {this.props.t("PaymentMethod.update")}
                        </div>
                      );
                    }}
                  />
                </div>
                {this.hasUploadedDeliveryNotes && (
                  <ItemDetails
                    date={
                      this.props.customerReservation.deliveryNotesData
                        .dealerActionDate
                    }
                    description={
                      <>
                        <span className={styles.acceptGreen}>
                          {this.props.t("PMDeliveryNotes.certificateUploaded")}
                        </span>
                        <span className={styles.detailsText}>
                          {CapitalizeText(
                            this.props.customerReservation.deliveryNotesData
                              .dealerActionUserId
                          )}
                        </span>
                      </>
                    }
                  />
                )}
              </div>
            );
          }}
        />

        <HasPermissionTo
          perform={["leaseContract:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={
            LowerCaseText(this.props.paymentType) === LEASE &&
            (LEASE_OPTIONS.ONLINE_APPROVED_MARKETS.includes(
              UpperCaseText(this.props.selectedMarket)
            ) ||
              IS_BRITAIN_MARKET(this.props.selectedMarket))
          }
          render={() => {
            return (
              <div data-testId="leaseFullPayment">
                <div className={styles.rowContainer}>
                  <CalendarDialog
                    {...this.props}
                    id="leaseFullPayment"
                    saveCalendarDate={this.saveLeaseOption} //create method to save new date
                    todayDate={this.props.customerReservation.todayDate}
                    type={LEASE_OPTIONS.LEASE_PAYMENT_CONFIRMED}
                    checkBoxText={this.props.t("PMLeasePayment.leasePayment")}
                    isDisabled={this.isLeasePaymentCheckboxDisabled()}
                    isChecked={this.hasCompletedLeasePayment}
                    hasMaxDate={true}
                    dialogTitle={this.props.t("PMLeasePayment.dateSigned")}
                    dialogDescription={this.props.t(
                      "PMLeasePayment.dialogDescription"
                    )}
                  />
                </div>
                {this.hasCompletedLeasePayment && (
                  <ItemDetails
                    date={
                      this.props.customerReservation.finalPaymentConfirmedData
                        .dealerAcceptedDate
                    }
                    description={
                      <>
                        <span className={styles.acceptGreen}>
                          {this.props.t("PMLeasePayment.eSigned")}
                        </span>
                        <span className={styles.detailsText}>
                          &nbsp;
                          {CapitalizeText(
                            this.props.customerReservation
                              .finalPaymentConfirmedData.dealerActionUserId
                          )}
                        </span>
                      </>
                    }
                  />
                )}
              </div>
            );
          }}
        />

        <TermsDialog
          open={this.state.openDealerInvoiceDialog}
          forAll={false}
          dialogBody={this.props.t("PMDealerInvoice.dialogDescription")}
          dialogTitle={this.props.t("PMDealerInvoice.dialogHeader")}
          saveText={this.props.t("PMDealerInvoice.upload")}
          currentDealerId="this.selectedDealer"
          confirmAction={this.uploadDealerInvoice}
          onClose={this.toggleDealerInvoiceDialog}
        />
        {/* Certificate Dialog box */}
        <TermsDialog
          open={this.state.openDeliveryCertificateDialog}
          forAll={false}
          dialogBody={this.props.t("PMDeliveryCertificate.dialogDescription")}
          dialogTitle={this.props.t("PMDeliveryCertificate.dialogHeader")}
          saveText={this.props.t("PMDeliveryCertificate.upload")}
          currentDealerId="this.selectedDealer"
          confirmAction={this.uploadRegistrationCertificate}
          onClose={this.toggleRegistrationCertificateDialog}
        />

        {/* Delivery Notes Dialog box */}
        <TermsDialog
          open={this.state.openDeliveryNotesDialog}
          forAll={false}
          dialogBody={this.props.t("PMDeliveryNotes.dialogDescription")}
          dialogTitle={this.props.t("PMDeliveryNotes.dialogHeader")}
          saveText={this.props.t("PMDeliveryNotes.upload")}
          currentDealerId="this.selectedDealer"
          confirmAction={this.uploadDeliveryNotes}
          onClose={this.toggleDeliveryNotesDialog}
        />

        <RegistrationNumberDialog
          {...this.props}
          open={this.state.openRegistrationNumberDialog}
          close={this.toggleRegistrationNumberDialog}
          maxDate={new Date()}
          minDate={null}
          saveRegistrationData={this.saveRegistrationData}
          fromNscDealerSearch={this.props.fromNscDealerSearch}
        />
      </div>
    );
  }
}

export default withTranslation("emp")(LeaseOptions);
